import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid-container mt-0" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"flex-end","gap":"8px","margin-top":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGridRef",
      allowColumnReordering: true,
      "data-source": _ctx.companies,
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnMinWidth: 50,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-column-lines": false,
      onSelectionChanged: _ctx.onSelectionChanged,
      onRowRemoving: _ctx.onRowRemoving,
      onEditingStart: _ctx.onEditingStart
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxPaging, {
          "page-size": 15,
          "page-index": 1
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          "storage-key": "Utilizatori"
        }),
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: "Cauta ..."
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxEditing, {
          allowUpdating: true,
          allowDeleting: true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 550,
              height: 350
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.successButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "before",
                  options: {
            text: 'Resetează parola',
            type: 'default',
            stylingMode: 'outlined',
            onClick: _ctx.onResetPassword
          }
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, {
              "col-span": 1,
              "col-count": 1,
              "item-type": "group"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  "data-field": "Active",
                  "editor-type": "dxCheckBox"
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Email",
                  "editor-options": { width: '100%' },
                  label: { text: 'Email', location: 'top' }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "AgentDefault",
                  "editor-type": "dxSelectBox",
                  label: { text: 'Agent Asociat' },
                  "editor-options": {
              dataSource: _ctx.dsAgenti,
              displayExpr: 'Nume',
              valueExpr: 'Id',
              searchEnabled: true,
              searchMode: 'contains',
              searchExpr: 'Nume',
              placeholder: 'Căutați agentul...',
              noDataText: 'Nu există agenți care să corespundă'
            }
                }, null, 8, ["editor-options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          caption: "Utilizator",
          "data-field": "Username"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AgentDefault",
          caption: "Agent Asociat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsAgenti,
              "value-expr": "Id",
              "display-expr": "Nume"
            }, null, 8, ["data-source"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, { "data-field": "Email" }),
        _createVNode(_component_DxColumn, { "data-field": "Active" })
      ]),
      _: 1
    }, 8, ["data-source", "onSelectionChanged", "onRowRemoving", "onEditingStart"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      title: "Adăugare Utilizator",
      width: 600,
      height: 380
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_DxForm, { "form-data": _ctx.formData }, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                "col-span": 1,
                "item-type": "group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, {
                    "data-field": "ID",
                    "editor-type": "dxSelectBox",
                    label: { text: 'Utilizator' },
                    "editor-options": {
              items: _ctx.unallocatedUsers,
              displayExpr: 'Username',
              valueExpr: 'ID',
              searchEnabled: true,
              searchMode: 'contains',
              searchExpr: 'Username',
              placeholder: 'Selectați utilizatorul',
              noDataText: 'Nu am găsit utilizatori'
            }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "AgentDefault",
                    "editor-type": "dxSelectBox",
                    label: { text: 'Agent Asociat' },
                    "editor-options": {
                dataSource: _ctx.dsAgenti,
                displayExpr: 'Nume',
                valueExpr: 'Id',
                searchEnabled: true,
                searchMode: 'contains',
                searchExpr: 'Nume',
                placeholder: 'Căutați agentul...',
                noDataText: 'Nu există agenți care să corespundă'
              }
                  }, null, 8, ["editor-options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              onClick: _ctx.onSave
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              onClick: _ctx.onCancel
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}